var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnowledgeBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7889_101734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.1138V18.8638C12.5 19.1953 12.3683 19.5132 12.1339 19.7477C11.8995 19.9821 11.5815 20.1138 11.25 20.1138H8.75C8.41848 20.1138 8.10054 19.9821 7.86612 19.7477C7.6317 19.5132 7.5 19.1953 7.5 18.8638V15.1138",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.6138H12.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1.36377V2.61377",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 10.1138H2.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 3.86377L4.04167 4.7471",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.1138H17.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8757 3.86377L15.959 4.7471",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.69714C7.83152 9.69714 8.14946 9.82884 8.38388 10.0633C8.6183 10.2977 8.75 10.6156 8.75 10.9471V15.1138",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.1138V10.9471C11.25 10.6156 11.3817 10.2977 11.6161 10.0633C11.8505 9.82884 12.1685 9.69714 12.5 9.69714",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4338 15.1138H12.5671C13.4964 14.6535 14.2767 13.9398 14.8178 13.0551C15.359 12.1704 15.6389 11.1507 15.6255 10.1138C15.5998 8.62995 14.9989 7.2141 13.9495 6.16472C12.9001 5.11535 11.4843 4.51447 10.0005 4.48877C8.51665 4.51447 7.10079 5.11535 6.05142 6.16472C5.00205 7.2141 4.40116 8.62995 4.37546 10.1138C4.36199 11.1507 4.64197 12.1704 5.18311 13.0551C5.72425 13.9398 6.50448 14.6535 7.4338 15.1138Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7889_101734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.73877)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBulb);
export default __webpack_public_path__ + "static/media/knowledge-bulb.4f21699f3ab6a5fcd7309c3c10faf719.svg";
export { ForwardRef as ReactComponent };